import React, { useEffect, useState } from 'react';
import { useLocation} from 'react-router-dom';
import MyApi,{ baseURL }  from './MyApi';
import AsyncSelect from 'react-select/async';
import { isEmptyObject } from 'jquery';
import { Modal, Button } from 'react-bootstrap'
import {
  TreeGridComponent, ColumnsDirective, ColumnDirective, Inject, Toolbar,
  ExcelExport, Freeze, Resize, Sort, Filter } from '@syncfusion/ej2-react-treegrid';
import { L10n, setCulture, Ajax, getValue  } from '@syncfusion/ej2-base';
import { useTranslation } from 'react-i18next';


import RMstats from './RMstats';
import RMByTbStats from './RMByTbStats';



setCulture('ar');
L10n.load({
  'fr-FR': {
    'treegrid': {
      "EmptyRecord": "Aucun enregistrement à afficher",
      "Excelexport": "Excel-Export",
      "Csvexport": "CSV-Export",
      "Print": "Imprimer",
      "Search": "Recherche",
      "Clear": "Effacer la recherche",
    }
  },
  'ar-AE': {
    'treegrid': {
      "EmptyRecord": "لا توجد معطيات لعرضها",
      "Excelexport": "تصدير_Excel",
      "Csvexport": "تصدير_CSV",
      "Print": "طباعة",
      "Search": "بحث",
      "Clear": "مسح البحث",
    }
  }
});




function RecetteMensuelGrid() {


  let treegridInstance = TreeGridComponent;

  const { t,i18n } = useTranslation()
  const currentLanguageCode = i18n.language
  
  const [selectedValue, setSelectedValue] = useState(null);
  const [selectedYear, setSelectedYear] = useState(null);
  const [sortingOptions] = useState(   {columns: [{ field: 'Reference', direction: 'Ascending' }]});
  const [tb, setTb] = useState(null);
  const [article, setArticle] = useState(null);
  const [reference, setReference] = useState(null);
 
  let [rec_date, setRec_date] = useState(null);
  
  const [isShow, setShow] = useState(false)
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [typeChart, setTypeChart] = useState('line');


  useEffect(() => {


    fetch(baseURL + '/getInfos', {
			"method": "GET",
			"headers": {
			  "content-type": "application/json",
			  "accept": "application/json"
			},
		  })
		  .then(response => response.json())
		  .then(response => {

        setRec_date(response.rec_date);
       
        
		  })
		  .catch(err => {
			console.log(err);
		  })



    let chartTypeValue = document.getElementById('chartTypeValue');
    setTypeChart(chartTypeValue.value); 
      if(chartTypeValue){
       chartTypeValue.addEventListener("change", () => {
       setTypeChart(chartTypeValue.value); 
     });
     }
    } , []);



  const fetchYears = () => {
    return MyApi.get('/getAllYearRecette').then(result => {
      const res = result.data;
      return res;
    });
  }


  // handle selection
  const handleChange = value => {
    setSelectedValue(value);
    setSelectedYear(value.year);
    const recetteUrl = baseURL + '/getRecetteTableByYear/' + value.year;

    loadData(recetteUrl);

    
  }

  let loadData = (recetteUrl) => {

    const ajax = new Ajax(recetteUrl, "GET");
    treegridInstance.showSpinner();
    const treegrid = treegridInstance;
    ajax.send();
    ajax.onSuccess = (data) => {
      treegrid.hideSpinner();
      treegrid.dataSource = JSON.parse(data);

    
    };
  }


  let nameOfFile = "Budget_recette_mensuelle_" + selectedYear;

  let collapsedStatePersist = true;
 

  let toolbarClick = (args) => { 
    switch (args.item.id) {
      case treegridInstance.grid.element.id + '_excelexport':
        let excelExportProperties = {
          isCollapsedStatePersist: collapsedStatePersist,
          fileName: nameOfFile + '.xlsx',
          theme: {
            header: {
              fontSize: 16,
              bold: true,
              fontColor: "#007EDC"
            },
            record: {
              fontSize: 14,
              bold: true,
              fontColor: "#000000"
            }
          },
          header: {
            headerRows: 1,
            rows: [{
              cells: [{
                colSpan: 15,
                value: nameOfFile,
                style: { fontSize: 18, hAlign: "Center", bold: true, fontColor: "#F40007" }
              }]
            }]
          },
          footer: {
            footerRows: 1,
            rows: [{
              cells: [{
                colSpan: 15,
                value: "SUIFI",
                style: { fontSize: 18, hAlign: "Center", bold: true, fontColor: "#940004" }
              }]
            }]
          },

        };
        treegridInstance.excelExport(excelExportProperties);
        break;
      case treegridInstance.grid.element.id + '_csvexport':
        let csvExportProperties = {
          isCollapsedStatePersist: collapsedStatePersist,
          fileName: nameOfFile + '.csv',
        };
        treegridInstance.csvExport(csvExportProperties);
        break;
      case 'ExpandAll':
        if (!isEmptyObject(treegridInstance.dataSource)) {
          treegridInstance.expandAll()
        }

        break;
      case 'CollapseAll':
        if (!isEmptyObject(treegridInstance.dataSource)) {
          treegridInstance.collapseAll();
        }

        break;
      default:
      // do nothing
    }
  }



  let getExpandedRowKeysFunction= (args) => {
    treegridInstance.expandAtLevel(1);
}



 let rowDataBound = (args) => {
  if (args.data.level === 0) {
        args.row.classList.add('level0'); 
    }
  else if (args.data.level === 1) {
    args.row.classList.add('level1'); 
}
else if (args.data.level === 2) {
  args.row.classList.add('level2'); 
} 
else if (args.data.level === 3) {
  args.row.classList.add('level3'); 
} 
else if (args.data.level === 4) {
  args.row.classList.add('level4'); 
} 
else if (args.data.level === 5) {
  args.row.classList.add('level5'); 
}  



}


let doubleClick= (args) => {
 let taskId = getValue('TaskID', args.rowData); 
 let article = getValue(currentLanguageCode === 'fr'? 'Libelle':'Libelle_ar', args.rowData);
 let reference = getValue('Reference', args.rowData);  
 setTb(taskId);
 setArticle(article);
 setReference(reference);
    handleShow();
}




return ( 


    <div className="row">


      <Modal show={isShow} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title> {article} <i className='fa fa-certificate'></i> {reference}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          
        <RMByTbStats currentLanguageCode={currentLanguageCode} tb = {tb} selectedYear = {selectedYear} article = {article} reference = {reference} typeChart={typeChart}/>

        </Modal.Body>


        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
           <i className='fa fa-close'> </i> {t('fermer')}
          </Button>
        </Modal.Footer>
      </Modal>




<RMstats currentLanguageCode={currentLanguageCode} typeChart={typeChart}/>


<div className="col-md-12"><hr /></div>


      <div className="col-md-2 pad5">
        <AsyncSelect
          placeholder={t('VCHA')}
          cacheOptions
          defaultOptions
          value={selectedValue}
          getOptionLabel={e => e.year}
          getOptionValue={e => e.year}
          loadOptions={fetchYears}
          onChange={handleChange}
         
        />
      </div>

     

      <div className="col-md-4 offset-md-2 pad12">
       <span className='boldBlack'> {t('SMDRPA')}  : </span> <b className='boldRed'>{selectedYear}</b> 
      </div>

      <div className="col-md-4 pad12 textAlignEnd">
       <span className='boldBlack'> {t('DMAJ')}  : </span> <b className='boldRed'>{rec_date}</b> 
      </div>

      <div className="col-md-12 pad5">



        <TreeGridComponent ref={treegrid => treegridInstance = treegrid} hasChildMapping='IsParent' height="610" idMapping='TaskID'
          parentIdMapping='ParentItem' treeColumnIndex={0} allowPaging={false}
          allowExcelExport={true} enableHover={true} frozenColumns={2}
          toolbar={['Print', 'ExcelExport', 'CsvExport', 'Search', { text: t('ouvrir_tout'), tooltipText: t('ouvrir_tout'), prefixIcon: "e-expand", id: "ExpandAll" },
           { text: t('fermer_tout'), tooltipText: t('fermer_tout'), prefixIcon: "e-collapse", id: "CollapseAll" }]} toolbarClick={toolbarClick}
          allowResizing={true} allowSorting={true} enableCollapseAll={true} locale={currentLanguageCode === 'fr'? "fr-FR":"ar-AE"}
          enableRtl={currentLanguageCode=== 'fr'? false:true} dataBound={getExpandedRowKeysFunction}  rowDataBound={rowDataBound} sortSettings={sortingOptions}
          recordDoubleClick={doubleClick} >
          <Inject services={[Toolbar, ExcelExport, Freeze, Resize, Sort, Filter, Sort]} />
          <ColumnsDirective>
            <ColumnDirective field={currentLanguageCode === 'fr'? 'Libelle':'Libelle_ar'} headerText={t('rubrique')} textAlign={currentLanguageCode=== 'fr'? 'Left':'Right'} width='430'></ColumnDirective>
            <ColumnDirective field="Reference" headerText={t('article')} textAlign="Left" width='110' ></ColumnDirective>
            <ColumnDirective field="Prev" headerText={t('previsionnel')}  textAlign="Right" width='155'></ColumnDirective>
            <ColumnDirective field="Janvier" headerText={t('janvier')}  textAlign="Right" width='155'></ColumnDirective>
            <ColumnDirective field="Fevrier" headerText={t('fevrier')}  textAlign="Right" width='155'></ColumnDirective>
            <ColumnDirective field="Mars" headerText={t('mars')} textAlign="Right" width='155'></ColumnDirective>
            <ColumnDirective field="Avril" headerText={t('avril')} textAlign="Right" width='155'></ColumnDirective>
            <ColumnDirective field="Mai" headerText={t('mai')}  textAlign="Right" width='155'></ColumnDirective>
            <ColumnDirective field="Juin" headerText={t('juin')}  textAlign="Right" width='155'></ColumnDirective>
            <ColumnDirective field="Juillet" headerText={t('juillet')} textAlign="Right" width='155'></ColumnDirective>
            <ColumnDirective field="Aout" headerText={t('aout')} textAlign="Right" width='155'></ColumnDirective>
            <ColumnDirective field="Septembre" headerText={t('septembre')} textAlign="Right" width='155'></ColumnDirective>
            <ColumnDirective field="Octobre" headerText={t('octobre')}  textAlign="Right" width='155'></ColumnDirective>
            <ColumnDirective field="Novembre" headerText={t('novembre')}  textAlign="Right" width='155'></ColumnDirective>
            <ColumnDirective field="Decembre" headerText={t('decembre')}  textAlign="Right" width='155'></ColumnDirective>
            <ColumnDirective field="Complementaire" headerText={t('complementaire')}  textAlign="Right" width='155'></ColumnDirective>
          </ColumnsDirective>
        </TreeGridComponent>


      </div>

    </div>


  );
}

export default RecetteMensuelGrid;
